var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 col-lg-8" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("block-headline", {
          staticClass: "col-12 col-md-6 mb-3",
          attrs: { icon: _vm.activeTab.icon, text: _vm.activeTab.text }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.activeTab.value === "regionalGoods"
              ? _c("regional-goods")
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "offers" ? _c("offers") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "regionalServices"
              ? _c("regional-services")
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "nationalServices"
              ? _c("national-services")
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "brands" ? _c("brands") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "leaflets" ? _c("leaflets") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "vouchers" ? _c("vouchers") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "about" ? _c("about") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "gallery" ? _c("galleries") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab.value === "jobs" ? _c("jobs") : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }